module.exports = __webpack_public_path__ + "static/media/webcam-slash.ee51fdfd.svg";